// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 实体状态枚举 枚举类
 * 实体状态枚举
 */
export enum EnumElementStatus {
  /** 有效的 : 有效的 */
  Valid = 1,
  /** 修改中 : 修改中 */
  Update = 2,
  /** 已删除 : 已删除 */
  Deleted = 4,
  /** 已退回 : 已退回 */
  Back = 8,
  /** 审核中 : 审核中 */
  Audit = 16
}

/**
 * 实体状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumElementStatusMD {
  private static items = [
    new EnumItemMD('Valid', 1, '有效的', '有效的'),
    new EnumItemMD('Update', 2, '修改中', '修改中'),
    new EnumItemMD('Deleted', 4, '已删除', '已删除'),
    new EnumItemMD('Back', 8, '已退回', '已退回'),
    new EnumItemMD('Audit', 16, '审核中', '审核中')
  ];

  static getItem(enumItem: EnumElementStatus) {
    return this.items.find(item => item.name === EnumElementStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
